// The latest road map (render/roadMap), published for readers that are not the
// street lights — the radar draws its road layer from it. Subscribers are
// called once per new map.
const subs = new Set();

export const roadMapBridge = {
  map: null,
  publish(map) {
    this.map = map;
    if (typeof window !== 'undefined' && window.__look) window.__look.roadMap = map;   // dev handle
    subs.forEach((fn) => { try { fn(map); } catch (e) { console.warn('[roadmap] subscriber failed', e); } });
  },
  subscribe(fn) {
    subs.add(fn);
    if (this.map) fn(this.map);
    return () => subs.delete(fn);
  },
};

/**
 * Is the ground at (x, z) covered — a building or a prop, or ground the map
 * never saw (render/roadMap's BLOCK and unknown)? One reading for everyone who
 * asks "can someone stand / see / walk here" (camera shots, facing a wall, the
 * walk to a parked car). `outside` is the answer off the edge of the map; false
 * when there is no map yet (nothing is known to be in the way).
 */
export function coveredAt(x, z, outside = true) {
  const m = roadMapBridge.map;
  if (!m?.cls) return false;
  const u = m.unitsPerTexel || m.rect.w / m.w;
  const i = Math.floor((x - m.rect.minX) / u); const r = Math.floor((z - m.rect.minZ) / u);
  if (i < 0 || r < 0 || i >= m.w || r >= m.h) return outside;
  const c = m.cls[r * m.w + i];
  return c === 3 || c === 0;
}

/** Nothing covered on the straight line from a to b ([x, z]), past `skip` units at each end. */
export function lineClear(a, b, skip = 0) {
  const dx = b[0] - a[0]; const dz = b[1] - a[1];
  const L = Math.hypot(dx, dz);
  for (let d = skip; d <= L - skip; d += 0.2) {
    if (coveredAt(a[0] + (dx * d) / L, a[1] + (dz * d) / L)) return false;
  }
  return true;
}
